import { useInscalar } from '@ilg-core/inscalar-web/react'
import { useCallback } from 'react'

import { getFeatureFlagsForEvent } from '@mediaingenuity/totallymoney.cardloanutils'
import Cookies from 'js-cookie'

import {
    EventType,
    InscalarEventBase,
    InscalarEventsCore,
} from '@appTypes/InscalarEvents.interface'

import { getInscalarAppEnv } from '@utils/getInscalarAppEnv'
import { getPathnameFromAsPath } from '@utils/getPathnameFromAsPath'
import {
    getJourneyCategoryFromJourney,
    getJourneyFromUrl,
    getOrSetOriginalJourney,
    getStepFromUrl,
} from '@utils/inscalar'

import useFeatureFlags from './useFeatureFlags'
import { useInscalarPreviousStep } from './useInscalarPreviousStep'

export const COOKIE_CONSENT_KEY = 'cookieyes-consent'

const useLogInscalarEvent = () => {
    const { featureFlags } = useFeatureFlags()
    const { track } = useInscalar()
    const { advance } = useInscalarPreviousStep()

    const trackBase = useCallback(
        (
            eventType: EventType,
            data?: InscalarEventBase,
            eventName = 'frontend_event'
        ) => {
            const coreData: InscalarEventsCore = {
                event_type: eventType,
                env: getInscalarAppEnv(),
                client: 'web',
                filters: {
                    cookie_consents: Cookies.get(COOKIE_CONSENT_KEY),
                    experiment_ids:
                        getFeatureFlagsForEvent(featureFlags)?.split(';') ?? [],
                },
            }

            track(
                eventName,
                '8.0',
                {},
                {
                    journey: data?.journey,
                    journey_category: data?.journeyCategory,

                    original_journey: data?.originalJourney,
                    original_journey_category: data?.originalJourneyCategory,

                    step: data?.step,
                    previous_step: data?.previousStep,

                    // Fields that can't be overridden
                    ...coreData,
                }
            )
        },
        [featureFlags, track]
    )

    const trackPageView = useCallback(
        (url: string) => {
            const step = getStepFromUrl(getPathnameFromAsPath(url))
            const previousStep = advance(step)

            const journey = getJourneyFromUrl(url)
            const journeyCategory = getJourneyCategoryFromJourney(journey)

            const originalJourney = getOrSetOriginalJourney(
                journey,
                journeyCategory
            )

            trackBase('pageview', {
                journey,
                journeyCategory,

                originalJourney: originalJourney.journey,
                originalJourneyCategory: originalJourney.journeyCategory,

                step,
                previousStep,
            })
        },
        [advance, trackBase]
    )

    return {
        trackPageView,
    }
}

export default useLogInscalarEvent
